import { render } from "./RiskFactorView.html?vue&type=template&id=7069c5a9"
import script from "./RiskFactorView.js?vue&type=script&lang=js"
export * from "./RiskFactorView.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__